import { Component, Inject, Input, OnInit } from "@angular/core";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { forkJoin } from "rxjs";
import { CommonService } from "src/app/services/common.service";
import { GlobalVariable } from "../../app.component";
import { DataService } from "../../dataService/data.service";

@Component({
  selector: "app-monthly-reviews",
  templateUrl: "./monthly-reviews.component.html",
  styleUrls: ["./monthly-reviews.component.scss"],
})
export class MonthlyReviewsComponent implements OnInit {
  @Input() isTotalReviewAvailable: boolean;
  public loading = false;
  today: any = this.commonService.onDateFilter();
  gaugeType = "semi";
  public gaugeValue: number;
  public gaugeStyle: any;
  public gaugeStyle1: any;
  public chartStyle: any;
  gaugeLabel: string;
  gaugeAppendText: any;
  goalText: string;
  goalText1: string;
  goalText2: string;
  reviewGoal: number;
  reviewInvite: number;
  toolTip: string;
  toolTip1: string;
  needMore: number;
  reviewSent: any;
  goalHalfVal: number;
  overflowHidden: Boolean = false;
  private BASE_URL = GlobalVariable;
  outletId: string;

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private commonService: CommonService,
    private httpService: DataService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.outletId = this.storage.get("outlet_id");

    const data_service = this.httpService.get(
      this.BASE_URL.GOAL_READ_URL(this.outletId)
    );
    const res_sent = this.httpService.get(
      this.BASE_URL.MONTHLY_REVIEW_URL(this.outletId)
    );
    forkJoin([res_sent, data_service]).subscribe((res) => {
      this.reviewSent = res[0].data["reviews_received"];
      this.reviewGoal = res[1].data["goal"];

      this.goalHalfVal = Math.round(this.reviewGoal / 2);

      this.reviewInvite = Math.round(this.reviewGoal * 4);
      this.gaugeValue = Math.round((this.reviewSent / this.reviewInvite) * 100);

      this.gaugeStyle = {
        "background-color": "#03c0c2",
        color: "#ffffff",
        width: Math.round((this.reviewSent / this.reviewInvite) * 100) + "%",
      };
      this.gaugeStyle1 = {
        "background-color": "transparent",
        color: "#03c0c2",
        width: "0%",
      };
      this.chartStyle = {
        "background-color": "#03C0C2",
        width: Math.round((this.reviewSent / this.reviewGoal) * 100) + "%",
      };

      if (this.reviewGoal > this.reviewSent) {
        this.toolTip =
          Math.round((this.reviewSent / this.reviewGoal) * 100) + "% of ";
        this.toolTip1 = " target achieved";
      } else {
        this.toolTip = "You have achieved ";
        this.toolTip1 = " target";
        this.overflowHidden = true;
      }

      this.needMore = Math.round(100 - this.gaugeValue);
      this.loading = false;
    });
  }
}
